import React from "react";

const AddItemPlus = ({ isActive }) => {
  const [isHovered, setIsHovered] = React.useState(false);

  let plusColor = "var(--color-primary)";
  let showBackground = false;

  if (isHovered || isActive) {
    showBackground = true;
    plusColor = "#FFFFFF";
  }

  return (
    <span
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{ display: "inline-flex", alignItems: "center", justifyContent: "center" }}
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="27" height="27" viewBox="0 0 27 27" fill="none">
        {/* Circular background when active/hovered */}
        {showBackground && <circle cx="13.5" cy="13.5" r="13.5" fill="var(--color-primary)" />}

        {/* Circular border */}
        <circle cx="13.5" cy="13.5" r="13" stroke="var(--color-primary)" strokeOpacity="0.6" fill="none" />

        {/* Plus symbol */}
        <path
          d="M19.1875 12.1875H14.3125V7.3125C14.3125 6.86377 13.9487 6.5 13.5 6.5C13.0513 6.5 12.6875 6.86377 12.6875 7.3125V12.1875H7.8125C7.36377 12.1875 7 12.5513 7 13C7 13.4487 7.36377 13.8125 7.8125 13.8125H12.6875V18.6875C12.6875 19.1362 13.0513 19.5 13.5 19.5C13.9487 19.5 14.3125 19.1362 14.3125 18.6875V13.8125H19.1875C19.6362 13.8125 20 13.4487 20 13C20 12.5513 19.6362 12.1875 19.1875 12.1875Z"
          fill={plusColor}
        />
      </svg>
    </span>
  );
};

export default AddItemPlus;
